import React from "react";
import CollapsePlug from "components/faq";
import Privacy from "components/privacy";

import { Form, Row, Col, Input, Button, theme, message } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

import { apiPostContactUs } from "api";
import { useTranslation } from "react-i18next";
import { errorHandler } from "utility/functions/errorHandler";
import { gaHandleGaClickEvent } from "components/ga/index";

const About = () => {
  const { i18n, t } = useTranslation();
  // 中文版桌機標題旁會多一行英文；英文版標題本身就是英文，不再重複
  const isEnglish = i18n.language === "en";

  const { token } = theme.useToken();

  const itemStyles = {
    marginBottom: 24,
    background: "#282828",
    color: "red",
    borderRadius: token.borderRadiusLG,
    border: "none",
  };

  const onChange = (key) => {
    console.log(key);
  };
  const items = [
    {
      key: "1",
      label: t("about.question1"),
      style: itemStyles,
      children: (
        <p>{t("about.answer1")}</p>
      ),
    },
    {
      key: "2",
      label: t("about.question2"),
      style: itemStyles,
      children: (
        <p>{t("about.answer2")}</p>
      ),
    },
  ];

  const handleSend = async (value) => {
    try {
      const res = await apiPostContactUs(value);
      message.success(t("about.contactSuccess"));
      gaHandleGaClickEvent({ action: "送出聯繫表單" });
    } catch (error) {
      errorHandler(error, t);
    }
  };

  return (
    <>
      <div className="w-full px-2 py-4 mobile:px-4 desktop:px-32 desktop:py-10">
        <div className="rounded-3xl laptop:h-600 tablet:h-400 mobile:h-400 bg-[url('assets/about/about.png')] bg-cover bg-center bg-no-repeat"></div>
      </div>

      {/* 關於我們 */}
      <div className="w-full desktop:px-56 mobile:px-4 tablet:px-20 pb-16 text-left">
        <>
          <h4 className="m-0 pt-8 pb-6 desktop:pt-10 desktop:pb-8  text-white flex">
            {t("about.heading")}
            {!isEnglish && (
              <span className="hidden desktop:block">
                {t("about.heading", { lng: "en" })}
              </span>
            )}
          </h4>
          <p className="text-SKF-G-001">
            {t("about.subTitle")}
            <br />
            {t("about.description")}
            <br />
            <br />
            {t("about.secondDescription")}
            <br />
            <br />
            {t("common.contactUs")}
            <br />
            <a
              href="mailto:support@rftexp.com"
              className="bg-black text-white mobile:w-10/12 desktop:w-1/3 desktop:flex justify-between rounded-lg text-base underline"
            >
              <p className="text-SKF-G-001">support@rftexp.com</p>
            </a>
            {/* <a href="#" className="border-b-SKF-G-001 border-b">
              Facebook
            </a> */}
            <Button
              type="link"
              className="p-0"
              onClick={() =>
                window.open("https://www.facebook.com/Skylinefilm")
              }
            >
              <p className="text-SKF-G-001 underline">Facebook</p>
            </Button>
            <br />
            <Button
              type="link"
              className="p-0"
              onClick={() =>
                window.open("https://www.instagram.com/skylinefilmtw")
              }
            >
              <p className="text-SKF-G-001 underline">Instagram</p>
            </Button>
            <br />
            <br />
            <br />
            <br />
            <p>{t("about.taxId", { id: "51948318" })}</p>
            <p>捌肆捌伍有限公司</p>
          </p>
        </>
      </div>
      {/* 常見問題 */}
      <div className="w-full bg-SKF-G-001 desktop:h-[auto] desktop:px-56 mobile:px-4 tablet:px-20 pb-3 text-left">
        {/* <h4 className="m-0 pt-8 pb-6 desktop:pt-10 desktop:pb-8  text-black flex">
          常見問題
          <span className="hidden desktop:block">FAQ</span>
        </h4>
        <CollapsePlug
          items={items}
          bordered={false}
          defaultActiveKey={["1"]}
          onChange={onChange}
          className="text-left"
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          style={{
            background: "#CDCDCD",
            color: "white",
          }}
        /> */}
        <h4 className="text-black flex pt-5">
          {t("about.contactHeading")}
          {!isEnglish && (
            <span className="hidden desktop:block">
              {t("about.contactHeading", { lng: "en" })}
            </span>
          )}
        </h4>
        <Form onFinish={handleSend}>
          <Row gutter={16}>
            <Col sm={{ span: 12 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: t("common.form.requireMessage"),
                  },
                ]}
              >
                <Input placeholder="name" size="large" className="p-2" />
              </Form.Item>
            </Col>
            <Col sm={{ span: 12 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    required: true,
                    message: t("common.form.emailRequiredMsg"),
                  },
                ]}
              >
                <Input placeholder="email" size="large" className="p-2" />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: t("common.form.requireMessage"),
                  },
                ]}
              >
                <Input
                  placeholder="phone number"
                  size="large"
                  className="p-2"
                />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }} xs={{ span: 24 }} className="mb-4">
              <Form.Item
                name="content"
                rules={[
                  {
                    required: true,
                    message: t("common.form.requireMessage"),
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 5,
                  }}
                  placeholder="content"
                  size="large"
                  className="p-2"
                />
              </Form.Item>
            </Col>
            <Col sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="bg-black text-white py-2 px-5 h-auto"
                >
                  {t("common.form.submit")}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Privacy />
      </div>
    </>
  );
};

export default About;
